<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" lg="6" md="6" sm="6" xl="6" >
        <v-text-field
          v-model="component.physical_people.motherName"
          :readonly="component.justVisible"
          label="Nome da Mãe"
          outlined
          required
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="6" md="6" sm="6" xl="6">
        <v-text-field
          v-model="component.physical_people.fatherName"
          :readonly="component.justVisible"
          label="Nome do Pai"
          outlined
          required
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="4" md="4" sm="4" xl="4">
        <v-select
          v-model="component.physical_people.civilStatus"
          :readonly="component.justVisible"
          label="Estado Civil"
          outlined
          :items="items_civilStatus"
          required
        >
        </v-select>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="4" xl="4">
        <v-text-field
          v-model="component.physical_people.spouse"
          :readonly="component.justVisible"
          label="Cônjugue"
          outlined
          required
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" md="4" sm="4" xl="4">
        <v-text-field
          v-model="component.physical_people.icomeSpouse"
          :readonly="component.justVisible"
          label="Renda Cônjugue"
          type="number"
          outlined
          required
        >
        </v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    component: Object(),
  },

  data: () => ({
    items_civilStatus: [
      "Casado(a)",
      "Divorciado(a)",
      "Solteiro(a)",
      "Viúvo(a)",
    ],
  }),

  methods: {
    clear() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style>
</style>